import { useQuery } from '@tanstack/react-query';
import { claimsApi } from '../api/claims';

const POLL_INTERVAL_MS = 30_000;

export function useMyClaimNotifications() {
  return useQuery({
    queryKey: ['claims', 'my-notifications'],
    queryFn: claimsApi.myNotifications,
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    staleTime: 5_000,
  });
}
